import { useTheme } from '@material-ui/core/styles';
import { CardType, CardVariant, LinkCardProps } from '../../lib/types';
import { Card } from '../../core/card';

export const LinkCard = (props: LinkCardProps) => {
  const theme = useTheme();
  const { link, target } = props;

  const cardTarget = target ?? '_blank';

  const cardProps = {
    ...props,
    target: cardTarget,
    type: CardType.link,
    variant: CardVariant.minimal,
    actionable: true,
    actionRoute: link.link,
    withoutTheme: true,
  };

  return (
    <Card.Root {...cardProps}>
      <Card.Card>
        <Card.Actionable
          cardProps={cardProps}
          style={{ padding: theme.spacing(0) }}
        >
          <Card.Title />
          <Card.Content />
        </Card.Actionable>
      </Card.Card>
    </Card.Root>
  );
};
